import utils from './utils';

const URL = `${BASE_API_URL}/cabinet`;

export default {
    teacherMenu: () => utils.get(`${URL}/teacher_menu/`),
};



// WEBPACK FOOTER //
// ./src/api/cabinet.js